module.exports = __webpack_public_path__ + "static/01-26af1fbba19882b588a5b7b337c5099f.png";